import { TextInput, View, type TextInputProps } from "react-native";
import { control, spacing, useTheme } from "~/styles/theme";
import { CaptionText } from "./Text";

type Props = TextInputProps & { label: string };

export function TextField({ label, style, ...rest }: Props) {
  const { colors } = useTheme();
  return (
    <View style={{ gap: spacing.xxs }}>
      <CaptionText
        color={colors.muted}
        style={{ textTransform: "uppercase", letterSpacing: 0.6 }}
      >
        {label}
      </CaptionText>
      <TextInput
        placeholderTextColor={colors.placeholder}
        style={[
          {
            height: control.height,
            borderWidth: 1,
            borderColor: colors.ruleStrong,
            paddingHorizontal: spacing.sm,
            fontSize: 16,
            fontFamily: "Inter_400Regular",
            color: colors.ink,
            backgroundColor: colors.surface,
          },
          style,
        ]}
        {...rest}
      />
    </View>
  );
}
